<template>
  <div>
    <div v-if="dates.length">
      <h5 class="font-md wt-md align-center">Available dates</h5>
      <litepicker
          :inline="true"
          :multi="true"
          :range="true"
          :months="2"
          :disable-dates="dates"
          @input="() => {}"
      >
      </litepicker>
    </div>
    <div v-else>
      Loading...
    </div>
  </div>
</template>

<script>
// TODO loader
// TODO disable interaction
export default {
  props: {
    listingId: {
      type: String,
      required: true
    }
  },
  created () {
    this.dates = []
    axios.get(`/api/listing/availability/${this.listingId}`)
        .then(response => {
          this.dates = response.data
        })
        .catch(() => {})
        .then(() => {})
  },
  data () {
    return {
      dates: []
    }
  }
}
</script>
